import { ExtendedBaseProfileField } from '../../../core/profiles/entities/extended-profile-field.entity';
import { ProfileFieldScope } from '../../../core/profiles/entities/profile-field.entity';

export function showEditableField(
    field: ExtendedBaseProfileField,
    canViewStandard: boolean,
    canEditStandard: boolean,
    canViewAdvanced: boolean,
    canEditAdvanced: boolean,
    hideNonEditableFields: boolean
): boolean {
    // If setting is enabled to hide non-editable fields, only show the field if it's editable
    if (hideNonEditableFields && !isEditable(field, canEditStandard, canEditAdvanced)) {
        return false;
    }

    if (field.Scope === ProfileFieldScope.Standard) {
        return canViewStandard;
    }

    if (field.Scope === ProfileFieldScope.Advanced) {
        return canViewAdvanced;
    }

    return true;
}

function isEditable(field: ExtendedBaseProfileField, canEditStandard: boolean, canEditAdvanced: boolean): boolean {
    switch (field.Scope) {
        case ProfileFieldScope.Standard:
            return canEditStandard && !field.ReadOnly;

        case ProfileFieldScope.Advanced:
            return canEditAdvanced && !field.ReadOnly;

        default:
            return !field.ReadOnly;
    }
}
